import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ZoomModal, ZoomBtn, ZoomField } from './zoom/ZoomTable';

// Move a user to another customer (2026-10-23): choose the customer, see exactly what moves
// (extension, own numbers, calls not yet invoiced, queues, caller ID), then confirm.
const err = (e: any) => e?.response?.data?.error || e?.message || 'Something went wrong';

export default function MoveUserDialog({ user, onClose, onDone }: { user: { id: number; name: string; customer_id?: any }; onClose: () => void; onDone: () => void }) {
  const [customers, setCustomers] = useState<any[]>([]);
  const [to, setTo] = useState('');
  const [plan, setPlan] = useState<any>(null);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState<any>(null);
  useEffect(() => { axios.get('/api/customers/config').then((r) => setCustomers((r.data?.customers || []).filter((c: any) => c.status === 'active'))).catch(() => {}); }, []);
  useEffect(() => {
    setPlan(null); setMsg('');
    if (!to) return;
    axios.get('/api/customers/move-user/preview', { params: { user_id: user.id, to } }).then((r) => setPlan(r.data)).catch((e) => setMsg(err(e)));
  }, [to]); // eslint-disable-line react-hooks/exhaustive-deps
  const move = async () => {
    setBusy(true); setMsg('');
    try { const r = await axios.post('/api/customers/move-user', { user_id: user.id, to_customer_id: Number(to) }); setDone(r.data); onDone(); }
    catch (e) { setMsg(err(e)); }
    setBusy(false);
  };
  const li: React.CSSProperties = { padding: '4px 0', fontSize: 13 };
  return (
    <ZoomModal width={620} title={`Move ${user.name} to another customer`} onClose={onClose}
      footer={done ? <ZoomBtn variant="primary" onClick={onClose}>Done</ZoomBtn>
        : <><ZoomBtn onClick={onClose}>Cancel</ZoomBtn><ZoomBtn variant="primary" onClick={() => plan && !busy && move()}>{busy ? 'Moving…' : 'Move user'}</ZoomBtn></>}>
      {done ? (
        <div style={{ fontSize: 14 }}>
          <p><b>{user.name}</b> now belongs to <b>{done.summary.to.name}</b>.</p>
          <p style={{ fontSize: 13, color: '#374151' }}>{done.moved_calls ? `${done.moved_calls} calls not yet invoiced (${done.summary.to.currency} ${done.moved_amount}) moved to ${done.summary.to.name}'s account.` : 'There were no calls waiting to be invoiced.'}</p>
        </div>
      ) : <>
        <ZoomField label="Move to customer">
          <select value={to} onChange={(e) => setTo(e.target.value)}>
            <option value="">— choose —</option>
            {customers.filter((c) => String(c.id) !== String(user.customer_id || '')).map((c) => <option key={c.id} value={c.id}>{c.name} ({c.code})</option>)}
          </select>
        </ZoomField>
        {msg && <div style={{ color: '#b91c1c', fontSize: 13, margin: '6px 0' }}>{msg}</div>}
        {plan && (
          <div style={{ background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12 }}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>What happens — from {plan.from.name} to {plan.to.name}</div>
            <div style={li}>• Extension <b>{plan.extension ? plan.extension.number : 'none'}</b> stays the same{plan.extension && plan.extension.from_block ? ` and leaves ${plan.from.name}'s extensions (${plan.extension.from_block})` : ''}.</div>
            <div style={li}>• Own numbers moving with the person: <b>{plan.numbers.length ? plan.numbers.join(', ') : 'none'}</b>{plan.numbers.length ? ' — their monthly billing moves too' : ''}.</div>
            {plan.kept_main && <div style={{ ...li, color: '#b45309' }}>• {plan.kept_main} is {plan.from.name}'s main number — it stays with {plan.from.name} (change its routing there if needed).</div>}
            <div style={li}>• Calls not yet invoiced: <b>{plan.billing.unbilled_calls}</b> ({plan.to.currency} {plan.billing.unbilled_amount}) move to {plan.to.name}'s account.{plan.billing.invoiced_calls_stay ? ` ${plan.billing.invoiced_calls_stay} calls already invoiced stay on ${plan.from.name}'s invoices.` : ''}</div>
            <div style={li}>• Caller ID becomes <b>{plan.caller_id || 'unchanged'}</b>; location becomes <b>{plan.location || 'unchanged'}</b>.</div>
            {plan.queues_removed.length > 0 && <div style={li}>• Removed from {plan.from.name}'s queues: <b>{plan.queues_removed.join(', ')}</b>.</div>}
            <div style={{ ...li, color: '#6b7280' }}>Future calls are charged to {plan.to.name} straight away.</div>
          </div>)}
      </>}
    </ZoomModal>
  );
}
